const INTERVAL_DURATION = 3600000; // 1 hour = 60 minutes × 60 seconds = 3600 s × 1000 milliseconds = 3,600,000 ms

export class ThorService {
    public static $inject: string[] = [
        "authService",
        "timingService"
    ];

    constructor(
        private authService,
        private timing
    ) {
        // refresh accessToken (rights) every hour
        this.timing.setInterval(
            () => this.authService.refreshAccessToken().catch(_ => this.timing.stopInterval()),
            INTERVAL_DURATION
        );
    }
}
